import { useState } from 'react'

import Map from '@/components/myTicket/components/map/view'
import ParkinglotMapHeader from '@/components/myTicket/components/parkinglotMapHeader/view'
import ParkinglotMapInfo from '@/components/myTicket/components/parkinglotMapInfo/view'

import Shared from '@/shared'
import Cover from '@/shared/components/Cover'
import Toast from '@/shared/components/Toast'

interface ParkinglotDetailMapProps {
  isDetailMapOpen: boolean
  setIsDetailMapOpen: React.Dispatch<React.SetStateAction<boolean>>
  parkinglotName: string
  parkinglotAddress: string
  latitude: number
  longitude: number
  onClickNaviBtn: () => void
}

function ParkinglotDetailMap({
  isDetailMapOpen,
  setIsDetailMapOpen,
  parkinglotAddress,
  parkinglotName,
  latitude,
  longitude,
  onClickNaviBtn
}: ParkinglotDetailMapProps) {
  const [isShowToast, setIsShowToast] = useState(false)
  const [toastText, setToastText] = useState('')

  const copyAddress = async () => {
    try {
      await Shared.Utils.handleCopyClipBoard(parkinglotAddress!)
      setToastText('주차장 주소가 복사됐습니다.')
      setIsShowToast(!isShowToast)
    } catch (err: unknown) {
      setToastText('복사에 실패했습니다.')
      setIsShowToast(!isShowToast)
    }
  }

  const onCloseToastModal = () => {
    setIsShowToast((prev) => !prev)
  }
  return (
    <Cover id="layer3" zIndex={'z-300'} isOpen={isDetailMapOpen}>
      <ParkinglotMapHeader setIsDetailMapOpen={setIsDetailMapOpen} />
      <div className="relative z-1 flex h-full w-full bg-010">
        <Map lat={latitude} lng={longitude} />
      </div>
      <ParkinglotMapInfo
        parkinglotAddress={parkinglotAddress}
        parkinglotName={parkinglotName}
        onClick={copyAddress}
        onClickNaviBtn={onClickNaviBtn}
      />
      {isShowToast && <Toast text={toastText} onClose={onCloseToastModal} />}
    </Cover>
  )
}

export default ParkinglotDetailMap
